import React, { useEffect, useState } from 'react'
import BreadCrumb from '../../../components/common/BreadCrumb'
import { Col, Row } from 'react-bootstrap';
import { useModalHandler, useWebCam } from '../../../helper/custom_hook';
import dummyUser from "../../../assets/images/users/user-dummy-img.jpg";
import Camera from '../../../components/common/Camera';
import CustomSelect from '../../../components/CustomSelect';
import { getCities, getStates } from '../../../helper/constants';
import { course, enquiry } from '../../../helper/api_url';
import { swal } from '../../../helper/swal';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { setPreloader } from '../../../features/Ui/uiSlice';
import { useDispatch } from 'react-redux';
export const CreateEnquiry = () => {
    const { genders, status, toggleModal, userProfile, setUserProfile } = useModalHandler();
    const navigate = useNavigate();
    const { webcam, toggleWebcam, setCapturedImageToInput } = useWebCam(setUserProfile);
    const onSave = (f) => setCapturedImageToInput(f, document.getElementById("avatarInput"));
    const [phoneNumber, setPhoneNumber] = useState('');
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const handleSetPhone = (e) => { setPhoneNumber(e.target.value); }
    const handleWhatsAppChange = (e) => {
        const isChecked = e.target.checked;
        document.getElementById('whatsappNumber').value = isChecked ? phoneNumber : '';
    };
    const { data: courses = [], isLoading, isError, error } = useQuery({
        queryKey: ['courses'],
        queryFn: course.list,
        staleTime: 20 * 60 * 1000,
        cacheTime: 20 * 60 * 1000,
        select: (data) => data?.data?.course.map(course => ({ value: course.id, label: course.name }))
    });
    const courseList = [...courses, { value: 'other', label: 'Other' }];
    useEffect(() => { if (isError && error) { swal.error(error.response?.data.message || error.message); } }, [isError, error]);
    useEffect(() => { if (isError) swal.error(error.response ? error.response.data.message : error.message) }, [isError, error]);
    const mutation = useMutation({
        mutationFn: (formData) => enquiry.add(formData),
        onSuccess: (res) => {
            queryClient.invalidateQueries(["enquirys"]);
            dispatch(setPreloader({ loader: false, message: "" }));
            navigate('/enquiry');
        },
        onError: (err) => { swal.error(err.response ? err.response.data.message : err.message); dispatch(setPreloader({ loader: false, message: "" })); }
    });
    const handleEnquirySave = (e) => {
        e.preventDefault();
        dispatch(setPreloader({ loader: true, message: "Please wait ..." }));
        const formData = new FormData(e.target);
        mutation.mutate(formData);
    }
    return (
        <>
            <BreadCrumb title="Enquiry Form" prevPage="Enquiry" prevPath="/enquiry" />
            <form onSubmit={e => handleEnquirySave(e)}>
                <div className='row justify-content-center'>
                    <div className="col-lg-4 col-xs-12">
                        <div className="card">
                            <div className="card-header">
                                <h3 className='text-center'>Personal Info</h3>
                            </div>
                            <div className="card-body">
                                <Row>
                                    <Col className="text-center">
                                        <div className="profile-user position-relative d-inline-block mx-auto mb-2">
                                            <label htmlFor="avatarInput" className="cursor-pointer" >
                                                <img src={userProfile ? userProfile : dummyUser} htmlFor="avatarInput" className="rounded-circle avatar-lg img-thumbnail user-profile-image cursor" alt="" />
                                            </label>
                                            <div className="avatar-xs ms-0 me-5 mb-2 rounded-circle profile-photo-edit" style={{ marginLeft: "31px" }} >
                                                <input id="avatarInput" type="file" name="avatar" className="profile-img-file-input" accept="image/png, image/jpeg, image/jpg" onChange={(e) => onSave(e.target.files[0])} defaultValue="" />
                                            </div>
                                            <div className="avatar-xs rounded-circle profile-photo-edit">
                                                <div onClick={toggleWebcam} className="avatar-title rounded-circle bg-light text-body"  > <i className="ri-camera-fill"></i>  </div>
                                            </div>
                                        </div>
                                        {webcam ? (<div className="position-relative top-0 bottom-0 d-flex justify-content-center align-items-center start-0 end-0 modal-content border-0" style={{ zIndex: 9 }} ><Camera onSave={(f) => { onSave(f); toggleWebcam(); }} onClose={() => toggleWebcam()} /></div>) : null}
                                    </Col>
                                </Row>
                                <div className='row'>
                                    <div className="col-6">
                                        <label htmlFor="enquiryName" className="form-label">School Name</label>
                                        <input type="text" className="form-control" id='enquiryName' name="name" placeholder="Enter School Name" />
                                    </div>
                                    <div className="col-6">
                                        <label htmlFor="enquiryFatherName" className="form-label">Principal Name</label>
                                        <input type="text" className="form-control" id='enquiryFatherName' name="father_name" placeholder="Enter Principal Name" />
                                    </div>
                                    {/* <div className="col-6 mt-2">
                                        <label htmlFor="genderInput" className="form-label">City</label>
                                        <CustomSelect options={genders} isSearchable name='gender' />
                                    </div> */}
                                    <input type="hidden" name="gender" value={'others'} />
                                    <input type="hidden" className="form-control" id="qualification" value={'default'} name="qualification" placeholder="Enter Your Qualification" />

                                    <div className="col-6 mt-4">
                                        <div>
                                            <label htmlFor="phoneNumber" className="form-label">Phone</label>
                                            <input type="tel" className="form-control" name='phone' id="phoneNumber" placeholder="Enter Phone number" onChange={handleSetPhone} />
                                        </div>
                                    </div>
                                    <div className="col-6 mt-4">
                                        <div>
                                            <input type="checkbox" className='pt-2' id="samewhatsapp" onClick={handleWhatsAppChange} />  <label htmlFor="samewhatsapp" className="form-label">Is same as WhatsApp</label>
                                            <input type="tel" className="form-control" name='whatsapp' id="whatsappNumber" placeholder="Enter Whatsapp number" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer"></div>
                        </div>
                    </div>
                    <div className="col-lg-8 col-xs-12">
                        <div className="card">
                            <div className="card-header">
                                <h3 className='text-center'>Other Details</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-6 mt-2">
                                        <div>
                                            <label htmlFor="address1" className="form-label">Address </label>
                                            <textarea name="address_1" id="address_1" className="form-control" rows={1}></textarea>
                                        </div>
                                    </div>
                                    {/* <div className="col-6 mt-2">
                                        <div>
                                            <label htmlFor="state" className="form-label">State</label>
                                            <CustomSelect id='state' name="state" placeholder="Select" options={getStates} isSearchable />
                                        </div>
                                    </div> */}
                                    <input type="hidden" name="state" value={'default'} />
                                    <div className="col-6 mt-2">
                                        <div>
                                            <label htmlFor="district" className="form-label">District</label>
                                            <input type="text" className="form-control" id='district' name="district" placeholder="Enter District" />
                                        </div>
                                    </div>
                                    {/* <div className="col-6 mt-2">
                                        <div>
                                            <label htmlFor="pin" className="form-label">Pin code</label>
                                            <input type="number" className="form-control" id='pin' name="pin" placeholder="Enter pin code" />
                                        </div>
                                    </div> */}
                                    <input type="hidden" name="pin" value={221505} />
                                    <hr className='mt-3' />
                                    <div className="col-6">
                                        <div>
                                            <label htmlFor="course" className="form-label">Client Required </label>
                                            <CustomSelect name="course_id" isSearchable id='course' placeholder="Select...." options={courseList} />
                                        </div>
                                    </div>
                                    {/* <div className="col-6">
                                        <div>
                                            <label htmlFor="preffered_batch" className="form-label">Preffered Batch</label>
                                            <CustomSelect name="preffered_batch" id="preffered_batch" options={[{ value: 'morning', label: 'Morning' }, { value: 'evening', label: 'Evening' }, { value: 'afternoon', label: 'Afternoon' },]} />
                                        </div>
                                    </div> */}
                                    <input type="hidden" name="preffered_batch" value={'morning'} />
                                    {/* <div className="col-4 mt-2">
                                        <div>
                                            <label htmlFor="tryal_date" className="form-label">Trail start Date</label>
                                            <input type="date" className="form-control" id='tryal_date' name="tryal_date" />
                                        </div>
                                    </div> */}
                                    <input type="hidden" name="tryal_date" value={new Date().toISOString().split('T')[0]} />
                                    {/* <div className="col-4 mt-2">
                                        <div>
                                            <label htmlFor="tryal_period" className="form-label">Trail Period</label>
                                            <input type="number" defaultValue={4} className="form-control" id='tryal_period' name="tryal_period" />
                                        </div>
                                    </div> */}
                                    <input type="hidden" name="tryal_period" value={1} />
                                    <div className="col-6 mt-2">
                                        <div>
                                            <label htmlFor="joining_date" className="form-label">Follow up Date</label>
                                            <input type="date" className="form-control" id='joining_date' name="joining_date" />
                                        </div>
                                    </div>

                                    {/* feedback */}
                                    <div className="col mt-2">
                                        <div>
                                            <label htmlFor="feedback" className="form-label">Feedback / Remarks</label>
                                            <textarea name="feedback" id="feedback" className="form-control" rows={1}></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <div className="hstack gap-2 justify-content-center">
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}
